<template>
  <div style="height: 100%;width: 100%;overflow-x: hidden;overflow-y: hidden">
    <div style="height: 4%">
      <el-row :gutter="30">
        <el-col :span="12">
          <span style="font-size: 16px;font-weight: bold">维保日历：</span>
        </el-col>
        <el-col :span="12">
          <div style="font-size: 16px;font-weight: bold;margin-right: 10px">{{currentDate}} 日志：</div>
        </el-col>
      </el-row>
    </div>

    <el-container style="height: 52%">
      <el-aside width="49%"  class="border">
        <el-calendar v-model="value" ref="calendar">
          <template #header="{ date }">
            <span></span>
            <h2 style="font-size: 20px">{{ date }}</h2>
            <el-button-group>
              <el-button style="font-size: 16px" @click="selectDate('prev-month')"><el-icon><ElIconArrowLeft /></el-icon></el-button>
              <el-button style="font-size: 14px" @click="selectDate('today')">今</el-button>
              <el-button style="font-size: 16px" @click="selectDate('next-month')"><el-icon><ElIconArrowRight /></el-icon></el-button>
            </el-button-group>
          </template>
          <template #date-cell="{ data }">
            <div @click="showWorkDate(data.day)" :class="data.isSelected ?'dateDiv_1':'dateDiv'">
              <text :class="data.isSelected ? 'is-selected' : ''"  v-if="data.type === 'current-month'" class="dayDiv">
                {{ data.day.split('-').slice(2).join() >= 10 ? data.day.split('-').slice(2).join() : data.day.split('-').slice(2).join().replace(0, '') }}
              </text>
            </div>
          </template>
        </el-calendar>
      </el-aside>
      <div style="width: 2%"></div>
      <el-aside width="49%" class="border" style="overflow-y: hidden;">
        <div style="height: 10%;border-bottom: rgb(216, 220, 230) 1px solid;margin-top: 10px">
          <el-row>
            <el-col :span="12">
              <span style="font-size: 16px;font-weight: bold;margin-left: 10%;">时间</span>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 16px;font-weight: bold;">日志</div>
            </el-col>
          </el-row>
        </div>

        <div style="height: 90%;overflow-y: auto;" v-loading="loading" element-loading-text="数据加载中..." >
          <el-row style="margin-top: 10px" v-for="item in zhiZaoLogWorkData" :key="item">
            <el-col :span="24">
              <div style="font-size: 16px;margin-left: 5%;margin-bottom: 10px">
                {{item.create_time.toString().slice(11,16)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {{item.create_user_name}}&nbsp;&nbsp;{{item.text_result}}对{{item.type_name}}&nbsp;&nbsp;进行&nbsp;&nbsp;{{item.text_name}}检查。
              </div>
            </el-col>
          </el-row>
        </div>
      </el-aside>
    </el-container>
    <div style="height: 4%;line-height: 35px;">
      <span style="font-size: 16px;font-weight: bold;">{{currentDate}} 计划：</span>
      <span style="font-size: 16px;margin-left: 15%">已完成：{{ cnt }} / {{tableData.length}}</span>
    </div>
    <el-footer style="height: 46%;width: 100%;padding: 0;overflow-y: auto" >
      <el-table v-loading="loading"  element-loading-text="数据加载中..." :data="tableData" border  :header-cell-style="{textAlign: 'center'}"
                :cell-style="{ textAlign: 'center', width: '100%',}">
        <el-table-column prop="index" label="序号" width="80" fixed>
          <template v-slot="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="device_no" label="设备编号" min-width="100" />
        <el-table-column prop="name" label="设备名称" min-width="150" />
        <el-table-column prop="type_name" label="设备类型" min-width="100" />
        <el-table-column prop="department_name" label="部门" min-width="100" />
        <el-table-column prop="plan_type" label="计划类型" min-width="100" />
        <el-table-column prop="operator_user_name" label="操作人" min-width="100" />
        <el-table-column prop="schedule_name" label="进度" min-width="100" >
          <template v-slot="scope">
            <div v-if="scope.row.schedule_name === '未完成'" style="color: red">{{ scope.row.schedule_name }}</div>
            <div v-if="scope.row.schedule_name === '完成'" style="color: black">{{ scope.row.schedule_name }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-footer>
  </div>


</template>

<script>

import {useDateFormat} from "@vueuse/core";
import moment from "moment";

export default {
  name: "EqWorkCalendarZhiZao",
  data() {
    return {
      value: new Date(),
      dateMap: [],
      currentDate: useDateFormat(new Date(), 'YYYY-MM-DD'),
      tableData: [],
      cnt: 0,
      zhiZaoLogWorkData:[],
      loading: false,
    }
  }, methods: {
    //total查询 组件自带
    selectDate(value) {
      this.$refs.calendar.selectDate(value)
      let date = moment(this.value).format("YYYY-MM-DD")
      this.showWorkDate(date)
    },
    showWorkDate(day) {
      this.loading = true
      this.getZhiZaoLogWorkData(day);
      this.getZhiZaoPlanWorkData(day);
      setTimeout(()=>{
        this.loading = false;
      },500)

    },
    //获取制造工作日志
   async getZhiZaoLogWorkData(currentDate) {
      let params = {currentDate: currentDate}
      await this.$http('eqWorkCalendarZhiZaoService.getZhiZaoLogWorkData',params, false).then(data => {
        this.zhiZaoLogWorkData = data;
        this.currentDate = useDateFormat(currentDate, 'YYYY-MM-DD');
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },
    //获取制造工作计划
    async getZhiZaoPlanWorkData(currentDate) {
      this.cnt = 0;
      let params = {currentDate: currentDate}
      await this.$http('eqWorkCalendarZhiZaoService.getZhiZaoPlanWorkData',params, false).then(data => {
        this.tableData = data;
        this.currentDate = useDateFormat(currentDate, 'YYYY-MM-DD');
        for (let item of this.tableData) {
          if (item.schedule_name === '已完成') {
            this.cnt += 1;
          }
        }
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    }
  }, created() {
    this.showWorkDate(this.currentDate);
    // let timer = setInterval(() => {
    //   this.showWorkDate(this.currentDate)
    //   console.log("timer2=",timer)
    // },20000)

  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.is-selected {
  color: #1989fa;
}

.border :deep(.el-calendar-day) {
  box-sizing: border-box;
  padding: 0;
  height: 100%;
}

.dayDiv {
  font-size: 20px;
}

.dateDiv {
  text-align: center;
  height: 50px;
  line-height: 50px;
}

.dateDiv_1 {
  text-align: center;
  background-color: #c9f5cb;
  height: 50px;
  line-height: 50px;
}

.el-main{
  overflow-x: hidden;
}







/*.border :deep(.el-calendar__body) {*/
/*  padding: 0;*/
/*}*/


</style>